import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { EmpathySection } from './components/EmpathySection';
import { FailedSolutions } from './components/FailedSolutions';
import { ProtocolReveal } from './components/ProtocolReveal';
import { WhatYouGet } from './components/WhatYouGet';
import { ObjectionHandler } from './components/ObjectionHandler';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <main className="w-full min-h-screen bg-[#1a1714] text-[#f5efe6] overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <EmpathySection data-id="element-2" />
      <FailedSolutions data-id="element-3" />
      <ProtocolReveal data-id="element-4" />
      <WhatYouGet data-id="element-5" />
      <ObjectionHandler data-id="element-6" />
      <CTASection data-id="element-7" />
      <Footer data-id="element-8" />
    </main>;
}